import {Button} from "@material-tailwind/react";
import React, {Dispatch, SetStateAction} from "react";
import {useTranslation} from "react-i18next";
import {ChevronLeft, ChevronRight} from "@mui/icons-material";
import {SIZE_PAGINATION} from "../../../conf";
import ButtonsPagination from "./ButtonsPagination";

export interface PaginationProps {
    loading?: boolean;
    currentPage?: number;
    totalElements?: number;
    totalPages?: number;
    setIndex?: Dispatch<SetStateAction<number | undefined>>;
}

export const CustomPagination = ({
                               loading,
                               currentPage,
                               totalElements,
                               totalPages,
                               setIndex,
                           }: PaginationProps) => {
    const { t } = useTranslation("global") as { t: (key: string) => string }
    let pageLimit = SIZE_PAGINATION; // número de enlaces de página en la paginación
    let start = 0; // starting page
    let end = pageLimit; // ending page

    if ((currentPage || currentPage === 0) && (totalPages || totalPages === 0) && (totalElements || totalElements === 0)) {
        if (totalPages! <= pageLimit) {
            pageLimit = totalPages!;
        }
        // incrementa la página de inicio cuando la página actual es mayor que 2
        if (currentPage! - 2 >= 0) {
            start = currentPage! - 1;
        }
        // si llega al final del incremento de parada de paginación
        if (start + pageLimit >= totalPages!) {
            start = totalPages! - pageLimit;
        }
        // incrementa la página final cuando el actual + 2 excede el límite de página
        if (currentPage! + 2 >= pageLimit) {
            end = currentPage! + 3;
            pageLimit = end;
            if (totalPages! <= pageLimit) {
                pageLimit = totalPages!;
            }
        }
    }

    function getCurrentPage() {
        if (currentPage || currentPage === 0) {
            return currentPage
        }
        return 0
    }

    return (
        <>
            <div className={'flex flex-col w-full items-center'}>
                <div className="flex items-center gap-4">
                    <Button
                        placeholder='button'
                        variant="text"
                        className="flex items-center gap-2 rounded-full"
                        onClick={() => {if(setIndex && currentPage) setIndex(currentPage - 1)}}
                        disabled={currentPage === 0 || loading || !totalElements}
                    >
                        <ChevronLeft strokeWidth={2} className="h-4 w-4"/> {t('previous')}
                    </Button>
                    {totalElements && <ButtonsPagination {...{
                        loading,
                        pageLimit,
                        end,
                        start,
                        currentPage,
                        totalElements,
                        setIndex
                    }}/>}
                    <Button
                        placeholder='button'
                        variant="text"
                        className="flex items-center gap-2 rounded-full"
                        onClick={() => {if(setIndex && currentPage) setIndex(currentPage + 1)}}
                        disabled={(getCurrentPage() >= (totalPages! - 1)) || loading || !totalElements}
                    >
                        {t('next')}
                        <ChevronRight strokeWidth={2} className="h-4 w-4"/>
                    </Button>
                </div>
                <div className={'flex w-full items-center justify-center mt-2 text-pagination'}>
                    {t('page')} {totalElements === undefined || totalElements === 0 ? 0 : currentPage ? currentPage + 1 : '1'} {t('of')} {totalPages} {t('of')} {totalElements} {t('records')}
                </div>
            </div>
        </>
    );
}